import { render } from "./BreadcrumbComponent.vue?vue&type=template&id=3ea27792&scoped=true"
import script from "./BreadcrumbComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbComponent.vue?vue&type=script&lang=js"

import "./BreadcrumbComponent.vue?vue&type=style&index=0&id=3ea27792&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea27792"]])

export default __exports__